<script setup lang="ts">
import { provide } from 'vue'
import PublicLayout from './layout/PublicLayout.vue'

const props = defineProps<{
  currentPath?: string
  userSignedIn?: boolean
  userName?: string
  logoutPath?: string
  editProfilePath?: string
  loginPath?: string
  signupPath?: string
  reservationPath?: string
}>()

provide('userSignedIn', props.userSignedIn ?? false)
provide('userName', props.userName ?? '')
provide('logoutPath', props.logoutPath ?? '')
provide('editProfilePath', props.editProfilePath ?? '')
provide('loginPath', props.loginPath ?? '/users/sign_in')
provide('signupPath', props.signupPath ?? '/users/sign_up')
provide('reservationPath', props.reservationPath ?? '/users/sign_in')
</script>

<template>
  <PublicLayout :current-path="currentPath" />
</template>
